var _rect, _rect2, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCro1381CardMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 31,
    viewBox: "0 0 51 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.874837,
    y: 1.1036,
    width: 49.5833,
    height: 29.5833,
    rx: 6.45833,
    fill: "#FAFAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.874837,
    y: 1.1036,
    width: 49.5833,
    height: 29.5833,
    rx: 6.45833,
    stroke: "#495157",
    strokeWidth: 0.416667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1731 23.7578H21.1592V8.03174H30.1731V23.7578Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7315 15.8953C21.7301 14.3808 22.0836 12.886 22.7653 11.5238C23.447 10.1616 24.439 8.96788 25.6662 8.03292C24.1465 6.87349 22.3215 6.1525 20.3998 5.95234C18.4781 5.75217 16.5371 6.08091 14.7987 6.90099C13.0603 7.72107 11.5946 8.9994 10.5691 10.5899C9.54358 12.1804 8.99968 14.0189 8.99951 15.8953C8.99988 17.7714 9.54385 19.6096 10.5693 21.1999C11.5947 22.7901 13.0602 24.0683 14.7984 24.8883C16.5365 25.7084 18.4772 26.0372 20.3988 25.8372C22.3203 25.6373 24.1451 24.9166 25.6648 23.7576C24.438 22.8224 23.4464 21.6285 22.765 20.2664C22.0836 18.9043 21.7301 17.4095 21.7315 15.8953Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3327 15.8953C42.3325 17.7716 41.7886 19.6101 40.7631 21.2006C39.7376 22.7911 38.2719 24.0695 36.5335 24.8895C34.7951 25.7096 32.8541 26.0384 30.9324 25.8382C29.0106 25.638 27.1857 24.917 25.666 23.7576C28.0618 21.9265 29.6007 19.0855 29.6007 15.8953C29.6007 12.705 28.0618 9.86401 25.666 8.03292C27.1857 6.87349 29.0106 6.1525 30.9324 5.95233C32.8541 5.75217 34.7951 6.08091 36.5335 6.90099C38.2719 7.72107 39.7376 8.9994 40.7631 10.5899C41.7886 12.1804 42.3325 14.0189 42.3327 15.8953Z",
    fill: "#F79E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCro1381CardMastercard);
export default __webpack_public_path__ + "static/media/cro1381-card-mastercard.a146bda4.svg";
export { ForwardRef as ReactComponent };